import React, { useState, useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Header from "../../components/Header";
import { livetools } from "../../Constants/livetools";
import RadioItem from "../../components/RadioItem";
import Firebase from "../../firebasehelper";
import AddArticleModal from "../Articles/components/AddArticleModal";
import EditArticleModal from "../Articles/components/EditArticleModal";
import "./index.css";
import { idfields } from "../../Constants/idfields";

const BespokeId = () => {
  const history = useHistory();
  const location = useLocation();
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [menuToAddArticle, setMenuToAddArticle] = useState();
  const [articleToEdit, setArticleToEdit] = useState();
  const editArticleBtnRef = useRef();

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      setLoading(true);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (brand_data) {
          setLoading(false);
          setBrandData(brand_data);
        }
      });
    }
  }, [location]);

  /* starting of handler part */
  const handleYes = (menu) => async () => {
    const id_permissions = brand_data.id_permissions || {};
    await Firebase.updateBrandDataById(brand, {
      id_permissions: { ...id_permissions, [menu]: true },
    });
  };

  const handleNo = (menu) => async () => {
    const id_permissions = brand_data.id_permissions || {};
    await Firebase.updateBrandDataById(brand, {
      id_permissions: { ...id_permissions, [menu]: false },
    });
  };
  /* ending of handler part */
  const addArticle = async (article) => {
    article.time = new Date().getTime();
    const articleId = await Firebase.addBespokeArticle(
      article,
      brand_data.name
    );
    const bespokeArticles = brand_data.bespokeArticles || {};
    Firebase.updateBrandDataById(brand, {
      bespokeArticles: { ...bespokeArticles, [menuToAddArticle]: articleId },
    });
  };
  const renderMenus = () => {
    return (
      <div>
        {idfields.map((field) => (
          <Grid
            container
            spacing={3}
            style={{ alignItems: "center", marginBottom: "10px" }}
          >
            <Grid item xs={3}>
              <div className="group-label">{field.title}</div>
            </Grid>
            <Grid item xs={3}>
              <RadioItem
                // menuName={tool.title}
                checked={
                  brand_data.id_permissions
                    ? brand_data.id_permissions[field.name] !== false
                    : true
                }
                // icon={tool.img}
                onYes={handleYes(field.name)}
                onNo={handleNo(field.name)}
              />
            </Grid>
          </Grid>
        ))}
      </div>
    );
  };
  return (
    <div id="page-container" className="bespoke-explore-container">
      <Header
        username={username}
        role={role}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand}
      />
      <main id="main-container">
        <div className="bespoke-live-tools-content">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && (
            <div className="left-content">
              <h2>Bespoke ID</h2>
              {brand_data && renderMenus()}
            </div>
          )}
        </div>
      </main>
    </div>
  );
};
export default BespokeId;



// WEBPACK FOOTER //
// ./src/screens/BespokeId/index.js